import { AppConfig } from "../appConfig";
import { RouteNameEnum } from "../enums";
import i18n from "../translations/i18n";
import { getUrlByRouteName } from "../utils";

export const OnboardingMode = {
  Default: "onboarding",
  LeasinGo: "onboarding-leasingo",
  OnboardingAll: "onboarding-all",
  HR: "onboarding-hr",
  OnboardingVWFS: "onboarding-vwfs",
};

export const StorageName = {
  OnboardingBoardView: "onboarding-board-view",
};

export const FooterLinks = [
  { label: i18n.t("competence.app.footer.informationDuty"), url: getUrlByRouteName(RouteNameEnum.InformationDuty)?.url ?? '/' },
  { label: i18n.t("competence.app.footer.privacyPolicy"), url: getUrlByRouteName(RouteNameEnum.PrivacyPolicy)?.url ?? '/' },
  { label: i18n.t("competence.app.footer.regulations"), url: getUrlByRouteName(RouteNameEnum.Regulations)?.url ?? '/' },
  { label: i18n.t("competence.app.footer.trainingRegulations"), url: getUrlByRouteName(RouteNameEnum.TrainingRegulations)?.url ?? '/' },
  { label: i18n.t("competence.app.footer.help"), url: `mailto:${AppConfig.platformContactEmail}` },
];
